/**
 * Identifies watchable properties associated with layout container children.
 *
 * @module MW/layout/LayoutChildProperty
 * @copyright Copyright 2014-2015 The MathWorks, Inc.
 */
define([], function () {
    return {
        /**
         * The title string associated with a child
         * @static
         */
        TITLE: "title",

        /**
         * A variant of the title string suitable for display where brevity is important.
         * Generally this is optional.  The TITLE will be used if no SHORT_TITLE is provided.
         * @static
         */
        SHORT_TITLE: "shortTitle",

        /**
         * A description of the child.  This may appear as a tooltip in the UI.
         * @static
         */
        DESCRIPTION: "description",

        /**
         * The region in which a child is located {"top", "bottom", "left", "right" or "center")
         * @static
         */
        REGION: "region",

        /**
         * True if the child is open
         * @static
         */
        IS_OPEN: "isOpen",

        /**
         * True if child is enabled
         * @static
         */
        IS_ENABLED: "isEnabled",

        /**
         * True if it is permissible to collapse the child
         * @static
         */
        IS_COLLAPSIBLE: "isCollapsible",

        /**
         * True if the child is collapsed
         * @static
         */
        IS_COLLAPSED: "isCollapsed",

        /**
         * True if the child is expanded
         * @static
         */
        IS_EXPANDED: "isExpanded",

        /**
         * True if if is permissible to maximize the child
         * @static
         */
        IS_MAXIMIZABLE: "isMaximizable",

        /**
         * True if the child is maximized
         * @static
         */
        IS_MAXIMIZED: "isMaximized",

        /**
         * True if the child can be resized
         */
        IS_RESIZABLE: "isResizable",

        /**
         * True if the child can be selected
         * @static
         */
        IS_SELECTABLE: "isSelectable",

        /**
         * True if the child is selected
         * @static
         */
        IS_SELECTED: "isSelected",

        /**
         * True if the child is showing
         * @static
         */
        IS_SHOWING: "isShowing",

        /**
         * Array containing actions or action id strings that can be applied to the child.  These may be offered on a menu by a parent container.
         * @static
         */
        ACTIONS: "actions",

        /**
         * The relative (to other children) position of the child
         * @static
         */
        INDEX: "index",

        /**
         * The tile, within a TileContainer, containing the child
         * @static
         */
        TILE: "tile",

        /**
         * Array or strings indicating regions in which the child is allowed to appear
         * @static
         */
        PERMISSIBLE_REGIONS: "permissibleRegions",

        /**
         * The width that should be allocated to the child provided there is flexibility to do so.
         * If the value is >= 1 pixels are assumed.  If the value is >0 and < 1 it is interpreted as a fraction
         * of the container width.  Finally, if the value is <= 0 the width is obtained from the computed
         * style of the child.
         * @static
         */
        PREFERRED_WIDTH: "preferredWidth",

        /**
         * The height that should be allocated to the child provided there is flexibility to do so.
         * If the value is >= 1 pixels are assumed.  If the value is >0 and < 1 it is interpreted as a fraction
         * of the container height.  Finally, if the value is <= 0 the height is obtained from the computed
         * style of the child.
         * @static
         */
        PREFERRED_HEIGHT: "preferredHeight",

        /**
         * The minimum width in pixels that should be allocated to the child.
         * @static
         */
        MINIMUM_WIDTH: "minimumWidth",

        /**
         * The minimum height in pixels that should be allocated to the child.
         * @static
         */
        MINIMUM_HEIGHT: "minimumHeight",

        /**
         * Identifies membership in a set of objects such as buttons on a ButtonBar, tabs on a TabContainer or
         * documents in a DocumentContainer.
         * @static
         */
        SET_ID: "setId",

        /**
         * True if the child's title may be shortened to meet space constraints.  The interpretation of this
         * property depend on the context.
         */
        TITLE_SHORTENING_ALLOWED: "titleShorteningAllowed",

        /**
         * True if the child should be destroyed when it is closed.
         */
        DESTROY_ON_CLOSE: "destroyOnClose", 

        /**
         * AriaLabel used to define the content of the embedded uifigure for screen readers
         */
        ARIALABEL: "arialabel"
    };
});